
export interface OfferDetails {
  name: string;
  basePrice: number;
  pricePerRoom: number;
  pricePerSquareMeter: number;
  features: string[];
  warranty: string;
  installationTime: string;
}

export const offerOptions: Record<string, OfferDetails> = {
  standard: {
    name: "Standard",
    basePrice: 1000,
    pricePerRoom: 1200,
    pricePerSquareMeter: 45,
    features: [
      "Klimatyzatory standardowej klasy energetycznej",
      "Podstawowa gwarancja 2 lata",
      "Standardowy montaż",
      "Podstawowy filtr powietrza"
    ],
    warranty: "2 lata",
    installationTime: "3-5 dni roboczych"
  },
  premium: {
    name: "Premium",
    basePrice: 1800,
    pricePerRoom: 1500,
    pricePerSquareMeter: 60,
    features: [
      "Klimatyzatory najwyższej klasy energetycznej A+++",
      "Rozszerzona gwarancja 5 lat",
      "Profesjonalny montaż z maskownicami",
      "Zaawansowane filtry HEPA",
      "Sterowanie przez aplikację",
      "Cicha praca (od 19dB)"
    ],
    warranty: "5 lat",
    installationTime: "2-3 dni robocze"
  },
  exclusive: {
    name: "Exclusive",
    basePrice: 3000,
    pricePerRoom: 2000,
    pricePerSquareMeter: 80,
    features: [
      "Klimatyzatory najwyższej klasy energetycznej A+++",
      "Pełna gwarancja 7 lat",
      "Premium montaż z maskownicami",
      "Profesjonalne filtry HEPA z jonizacją",
      "Zaawansowane sterowanie przez aplikację",
      "Ultra cicha praca (od 16dB)",
      "Priorytetowy serwis 24/7",
      "Darmowy przegląd roczny"
    ],
    warranty: "7 lat",
    installationTime: "1-2 dni robocze"
  }
};

export const calculateOffer = (
  roomCount: number,
  squareMeters: number,
  offerType: keyof typeof offerOptions,
  installationType: 'home' | 'company' = 'home'
): number => {
  const { basePrice, pricePerRoom, pricePerSquareMeter } = offerOptions[offerType];
  
  // Base calculation + cost per room + cost per square meter
  let totalPrice = basePrice + (roomCount * pricePerRoom) + (squareMeters * pricePerSquareMeter);
  
  // If it's for a company, add 15% for commercial installation requirements
  if (installationType === 'company') {
    totalPrice *= 1.15;
  }
  
  return Math.round(totalPrice);
};

export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('pl-PL', { 
    style: 'currency', 
    currency: 'PLN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};
